import { render, staticRenderFns } from "./PartnersWordPress.vue?vue&type=template&id=7530d0e8&scoped=true"
import script from "./PartnersWordPress.vue?vue&type=script&lang=js"
export * from "./PartnersWordPress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530d0e8",
  null
  
)

export default component.exports